import { IUseTrainingPlansDrawerReturn, useTrainingPlansDrawer } from "@hooks/game/training-plans/use-training-plans-drawer";
import { createContext, ReactNode, useContext } from "react";

interface ITrainingPlansDrawerContextValue extends IUseTrainingPlansDrawerReturn {}

const TrainingPlansDrawerContext = createContext<ITrainingPlansDrawerContextValue | undefined>(undefined);

interface ITrainingPlansDrawerProvider {
  children: ReactNode;
}

export const TrainingPlansDrawerProvider = ({ children }: ITrainingPlansDrawerProvider) => {
  const value: ITrainingPlansDrawerContextValue = useTrainingPlansDrawer();

  return <TrainingPlansDrawerContext.Provider value={value}>{children}</TrainingPlansDrawerContext.Provider>;
};

export const useTrainingPlansDrawerContext = () => {
  const context = useContext(TrainingPlansDrawerContext);
  if (!context) {
    throw new Error("useTrainingPlansDrawerContext must be used within TrainingPlansDrawerProvider");
  }

  return context;
};
